import {initReactI18next} from 'react-i18next';

import i18n from 'i18next';
import locales from 'resources/Locales';

import i18nResources from './resources';

export const I18NEXT_NAMESPACE = 'translation';
export const I18NEXT_DEFAULT_LANGUAGE = locales.en;

if (!i18n.isInitialized) {
  i18n.use(initReactI18next).init({
    defaultNS: I18NEXT_NAMESPACE,
    fallbackLng: I18NEXT_DEFAULT_LANGUAGE,
    interpolation: {
      escapeValue: false,
      prefix: '__',
      suffix: '__',
    },
    ns: I18NEXT_NAMESPACE,
    react: {
      useSuspense: false,
    },
    resources: i18nResources(I18NEXT_DEFAULT_LANGUAGE),
  });
}
